/**
 * Immunization Service
 * Patient immunization records and vaccine tracking API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { VocabularyGroupResponseDto } from './vocabularyGroupResponseDto';


export interface VocabularyElementWithGroupResponseDto { 
    /**
     * Element identifier
     */
    id: string;
    /**
     * Collection identifier
     */
    collectionId: string;
    /**
     * Unique slug for the vocabulary element
     */
    slug: string;
    /**
     * Display name of the vocabulary element
     */
    display: string;
    /**
     * Description of the vocabulary element
     */
    description?: string;
    /**
     * Status of the vocabulary element
     */
    status: VocabularyElementWithGroupResponseDto.StatusEnum;
    /**
     * Metadata for the vocabulary element
     */
    metadata?: any;
    /**
     * Group this vocabulary element belongs to
     */
    group: VocabularyGroupResponseDto;
}
export namespace VocabularyElementWithGroupResponseDto {
    export type StatusEnum = 'draft' | 'active' | 'inactive';
    export const StatusEnum = {
        Draft: 'draft' as StatusEnum,
        Active: 'active' as StatusEnum,
        Inactive: 'inactive' as StatusEnum
    };
}


